<template>
  <div class="text-image-with-bg row-1" :class="[props.type, customStyle]">
    <div
      class="text-image-with-bg__container m-bot-8"
      :class="{ 'invert-order': block.invertiOrdine }"
      :style="block.coloreSfondo ? { '--bg-color': block.coloreSfondo } : {}"
    >
      <div class="text-image-with-bg__image">
        <div v-if="block.portrait.length">
          <WidgetPicture
            :image="{
              portrait: block.portrait?.[0],
            }"
            :alt="block.portrait?.[0]?.title"
          />
        </div>
      </div>
      <div class="text-image-with-bg__text">
        <div class="text-image-with-bg__content">
          <div v-if="block.sectionTitle">
            <div
              class="is-medium-bold"
              :class="props.type === 'custom3' ? 'title-big4' : ' title-large3'"
              :style="block.coloreTitolo ? { color: block.coloreTitolo } : {}"
              v-html="block.sectionTitle"
            />
          </div>
          <div v-if="block.text">
            <div
              :class="props.type === 'custom3' ? 'text-medium' : ' title-base'"
              v-html="block.text"
            />
          </div>
        </div>
        <div v-if="block.linkDefault">
          <NuxtLink :to="localePath(block.linkDefault)">
            <div class="text-medium5 default-icon-btn is-medium-bold">
              <span v-html="block.label" />
              <ArrowIcon alt="Arrow icon" class="icon-arrow" />
            </div>
          </NuxtLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import ArrowIcon from '@/assets/img/ico/arrow-mobile.svg'

const props = defineProps({
  block: {
    type: Object,
    default: () => ({}),
  },
  type: {
    type: String,
    default: 'default',
  },
  customStyle: {
    type: String,
    default: '',
  },
})
</script>

<script>
export default {
  name: 'TextImageWithBg',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
